var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex_gap_5" },
    [
      _c(
        "v-popover",
        { attrs: { "auto-hide": true } },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-xs btn-outline-success",
              attrs: { type: "button" },
            },
            [
              _c("i", { staticClass: "icon-fa icon-fa-phone-square" }),
              _vm._v(" Быстрый контакт\n    "),
            ]
          ),
          _vm._v(" "),
          _c("template", { slot: "popover" }, [
            _c("div", [
              _c("p", [
                _vm._v("Менеджер свяжется с клиентом для решения вопроса"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Вопрос по товару",
                      className: "btn btn-outline-info mb-1",
                      loading: _vm.actionBtnLoading,
                      color: _vm.$constants.LOADING_COLOR,
                      onClick: () => _vm.sendManagerRequest("drug"),
                    },
                  }),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "Вопрос по цене",
                      className: "btn btn-outline-info mb-1",
                      loading: _vm.actionBtnLoading,
                      color: _vm.$constants.LOADING_COLOR,
                      onClick: () => _vm.sendManagerRequest("price"),
                    },
                  }),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "Вопрос по адресу",
                      className: "btn btn-outline-info mb-1",
                      loading: _vm.actionBtnLoading,
                      color: _vm.$constants.LOADING_COLOR,
                      onClick: () => _vm.sendManagerRequest("address"),
                    },
                  }),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "Вопрос по оплате",
                      className: "btn btn-outline-info mb-1",
                      loading: _vm.actionBtnLoading,
                      color: _vm.$constants.LOADING_COLOR,
                      onClick: () => _vm.sendManagerRequest("payment"),
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-popover",
        { attrs: { "auto-hide": true } },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-xs btn-outline-info",
              attrs: { type: "button" },
            },
            [_c("i", { staticClass: "icon-fa icon-fa-info info_fa" })]
          ),
          _vm._v(" "),
          _c("template", { slot: "popover" }, [
            _c("div", [
              _c("p", { staticClass: "mb-2" }, [
                _vm._v(
                  'Цель запроса звонка оператора\n          - быстрый ответ на вопросы клиента\n          - "спасти" заказ во время доставки, или лучше до приезда к клиенту.'
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "О результатах диалога, оператор пишет сообщение по факту совершенного звонка."
                ),
              ]),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }